import { type FC } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, InputAdornment, TextField } from '@mui/material';

export interface LabelsToolbarProps {
  filter: string;
  onFilterChange: (value: string) => void;
  onNewGroup: () => void;
  onNewLabel: () => void;
}

/**
 * Linear-style header for the labels manager (GDN-2019): a name filter on the
 * left, "New group" / "New label" actions pushed to the right.
 */
export const LabelsToolbar: FC<LabelsToolbarProps> = ({
  filter,
  onFilterChange,
  onNewGroup,
  onNewLabel,
}) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
    <TextField
      size="small"
      placeholder="Filter by name…"
      value={filter}
      onChange={e => onFilterChange(e.target.value)}
      sx={{ width: { xs: 1, sm: 280 } }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        },
      }}
    />
    <Box sx={{ flex: 1 }} />
    <Button variant="outlined" onClick={onNewGroup}>
      New group
    </Button>
    <Button variant="contained" onClick={onNewLabel}>
      New label
    </Button>
  </Box>
);
